import React from 'react';
import cn from 'classnames';

import { ReactComponent as InfoIcon } from 'assets/imgs/info.svg';
import classes from './tooltip.module.scss';
import { ITooltip } from './types';

const Tooltip: React.FC<ITooltip> = ({
	className,
	text,
	icon = <InfoIcon />,
	tooltipClassName,
}) => {
	return (
		<div className={cn(classes.tooltip, className)}>
			{icon}
			<div className={cn(classes.tooltipText, tooltipClassName)}>
				{text}
			</div>
		</div>
	);
};

export default Tooltip;
